import arduino from './arduinoCompiler';
import codey from './codeyPreprocess';
export default {
    [arduino.name]: arduino.process,
    [codey.name]: codey.process,
};
